import { render } from "./WorkspaceFooter.vue?vue&type=template&id=49e46884&ts=true"
import script from "./WorkspaceFooter.vue?vue&type=script&lang=ts"
export * from "./WorkspaceFooter.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/timitools.webweb.works/client/timitools/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__